import { styled } from '@mui/material/styles';
import { Box, TextField } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px 16px',
    backgroundColor: theme.palette.background.default,
}));

export const FormContainer = styled(Box)(({ theme }) => ({
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 16px rgba(0, 0, 0, 0.08)',
    padding: '32px 24px',
    maxWidth: 500,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
}));

export const MessageBox = styled(Box)(({ theme }) => ({
    margin: '16px 0',
    padding: 16,
    borderRadius: 8,
    fontWeight: 500,
    textAlign: 'center',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
    margin: theme.spacing(1, 0),
    '& .MuiInputBase-root': {
        borderRadius: 8,
        backgroundColor: theme.palette.background.paper,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.divider,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
    },
    '& .MuiInputLabel-root': {
        color: theme.palette.primary.main,
    },
}));
